<template>
  <div class="reaction-picker-container" v-if="visible" @mouseleave="closePicker">
    <div class="reaction-quick-bar">
      <span
        class="quick-emoji"
        v-for="emoji in quickEmojis"
        :key="emoji"
        @click="selectEmoji(emoji)"
      >{{ emoji }}</span>
      <span class="quick-emoji add-more" @click="toggleFullPicker">+</span>
    </div>
    <div class="full-picker-wrapper" :class="pickerDirection" v-if="showFullPicker">
      <Picker
        :data="emojiIndex"
        native
        :showPreview="false"
        :showSkinTones="false"
        :emojiSize="24"
        :perLine="8"
        :i18n="i18n"
        @select="onEmojiSelect"
      >
        <template slot="searchTemplate"><span></span></template>
        <template slot="previewTemplate"><span></span></template>
      </Picker>
    </div>
  </div>
</template>

<script>
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import data from 'emoji-mart-vue-fast/data/all.json'
import 'emoji-mart-vue-fast/css/emoji-mart.css'

const emojiIndex = new EmojiIndex(data)

export default {
  components: { Picker },

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      quickEmojis: ['👍', '❤️', '😂', '😮', '😢', '👏'],
      showFullPicker: false,
      pickerDirection: 'up',
      emojiIndex: emojiIndex,
      i18n: {
        search: 'Ara...',
        categories: {
          search: 'Arama sonuçları',
          recent: 'Son kullanılan',
          smileys: 'Yüzler & İfadeler',
          people: 'İnsanlar & Vücut',
          nature: 'Hayvanlar & Doğa',
          foods: 'Yiyecek & İçecek',
          activity: 'Aktivite',
          places: 'Seyahat & Yerler',
          objects: 'Nesneler',
          symbols: 'Semboller',
          flags: 'Bayraklar',
          custom: 'Özel'
        }
      }
    }
  },

  methods: {
    selectEmoji (emoji) {
      this.$emit('select', emoji)
      this.showFullPicker = false
    },
    onEmojiSelect (emoji) {
      this.$emit('select', emoji.native)
      this.showFullPicker = false
    },
    toggleFullPicker (event) {
      if (!this.showFullPicker) {
        const rect = event.currentTarget.getBoundingClientRect()
        const pickerHeight = 380
        const spaceBelow = window.innerHeight - rect.bottom
        this.pickerDirection = spaceBelow >= pickerHeight ? 'down' : 'up'
      }
      this.showFullPicker = !this.showFullPicker
    },
    closePicker () {
      this.$emit('close')
      this.showFullPicker = false
    }
  }
}
</script>

<style lang="less" scoped>
.reaction-picker-container {
  position: absolute;
  top: -44px;
  left: 0;
  z-index: 9999;
}

.full-picker-wrapper {
  position: absolute;
  left: 0;

  &.up {
    bottom: 100%;
    margin-bottom: 4px;
  }

  &.down {
    top: 100%;
    margin-top: 4px;
  }
}

.reaction-quick-bar {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px 6px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.quick-emoji {
  font-size: 20px;
  cursor: pointer;
  padding: 3px 4px;
  border-radius: 8px;
  transition: all 0.15s ease;
  line-height: 1;
  user-select: none;

  &:hover {
    background: #f0f0f0;
    transform: scale(1.2);
  }
}

.add-more {
  font-size: 16px;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f5f5f5;

  &:hover {
    background: #e0e0e0;
    color: #555;
  }
}

</style>

<style lang="less">
.messageBalloonMainReverse .reaction-picker-container {
  left: auto;
  right: 0;
}
.messageBalloonMainReverse .full-picker-wrapper {
  left: auto;
  right: 0;
}
</style>
